// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Z1V_Nsc6tZ","fullTable":"FdfCnFHoq9 tableList"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/presentational/PaymentAmountTable/PaymentAmountTable.module.less
// module id = 1001
// module chunks = 3